import { render, staticRenderFns } from "./CargoBikeInsurance.vue?vue&type=template&id=2b4d39ea&scoped=true"
import script from "./CargoBikeInsurance.vue?vue&type=script&lang=js"
export * from "./CargoBikeInsurance.vue?vue&type=script&lang=js"
import style0 from "./CargoBikeInsurance.vue?vue&type=style&index=0&id=2b4d39ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d39ea",
  null
  
)

export default component.exports